/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-15 10:43:47
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2026-10-30 10:54:47
 */

import { getAllCountries, getAllArea, getModelBySerialNumber, submitInfo, checkInvitationCode, getAngioPdf, submitAngio, submitIMR, getIMRPdf } from '@/api/apiApp'
import { getSessionStorage, setSessionStorage } from '@/utils/sessionStorage'
import { aseEncode, aseDecode } from '@/utils/common'

const state = {
  device: 'pc', // 环境，电脑端：pc   移动端：m
  language: getSessionStorage('lg') == null ? 'zh' : aseDecode(getSessionStorage('lg'), 'GTRYRT%^&*%^865745tedSFWER235t4t,kl3') === 'en' ? 'en' : 'zh', // zh：中文   en：英文
  i18nLocale: getSessionStorage('il') == null ? 'zh' : aseDecode(getSessionStorage('il'), 'brgr&%^&%GV bfh567657%^&') === 'en' ? 'en' : 'zh',
  scrollTop: 0, //
  clientWidth: 0, // 屏幕宽度
  clientHeight: 0 // 屏幕高度
}

const mutations = {
  SET_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
    setSessionStorage('lg', aseEncode(language, 'GTRYRT%^&*%^865745tedSFWER235t4t,kl3'))
  },
  SET_I18N_LOCALE: (state, i18nLocale) => {
    state.i18nLocale = i18nLocale
    setSessionStorage('il', aseEncode(i18nLocale, 'brgr&%^&%GV bfh567657%^&'))
  },
  SET_SCROLL_TOP: (state, scrollTop) => {
    state.scrollTop = scrollTop
  },
  SET_CLIENT_HEIGHT: (state, clientHeight) => {
    state.clientHeight = clientHeight
  },
  SET_CLIENT_WIDTH: (state, clientWidth) => {
    state.clientWidth = clientWidth
  }
}

const actions = {
  setDevice ({ commit }, device) {
    commit('SET_DEVICE', device)
  },
  setLanaguage ({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  setI18nLocale ({ commit }, i18nLocale) {
    commit('SET_I18N_LOCALE', i18nLocale)
  },
  setScrollTop ({ commit }, scrollTop) {
    commit('SET_SCROLL_TOP', scrollTop)
  },
  setClientWH ({ commit }, { clientWidth, clientHeight }) {
    commit('SET_CLIENT_WIDTH', clientWidth)
    commit('SET_CLIENT_HEIGHT', clientHeight)
  },
  getAllCountries ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      getAllCountries(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllArea ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      getAllArea(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getModelBySerialNumber ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      getModelBySerialNumber(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  submitInfo ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      submitInfo(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  checkInvitationCode ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      checkInvitationCode(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAngioPdf ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      getAngioPdf(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  submitAngio ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      submitAngio(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  submitIMR ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      submitIMR(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getIMRPdf ({ commit }, parms) {
    return new Promise((resolve, reject) => {
      getIMRPdf(parms).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
